import React from 'react'
import TextField from '@material-ui/core/TextField'
// @src imports
import { SponsorFragment } from 'src/graphql'
import {
  useCallback,
  useDebounce,
  useEffect,
  useRef,
  useState,
} from 'src/hooks'

import styles from '../styles/account.module.scss'
import { Memoized } from 'src/hooks/dependencies'
import SponsorPopover from './SponsorPopover/SponsorPopover'

type Props = {
  onSelect: (sponsor: SponsorFragment) => void
  setPickingState: Memoized<(picking: boolean) => void>
}

const SponsorPicker: React.FC<Props> = props => {
  const { onSelect, setPickingState } = props

  const [error, setError] = useState<string | undefined>()

  const [isOpen, setIsOpen] = useState(false)
  const [searchText, setSearchText] = useState('')
  const debouncedSearch = useDebounce(searchText, 500)

  const containerRef = useRef<HTMLDivElement>(null)
  const onOpen = () => setIsOpen(true)
  const onClose = () => {
    setIsOpen(false)
    if (searchText) {
      onError('Please select a sponsor or clear the input before joining.')
    }
  }
  const onSearch = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => setSearchText(e.target.value),
    [],
  )
  const onError = (error?: string) => {
    setError(error)
  }

  useEffect(() => setPickingState(!!searchText), [searchText, setPickingState])

  return (
    <div className={styles.oneField}>
      <div
        style={{
          position: 'relative',
          display: 'inline-block',
          width: '100%',
        }}
      >
        <div ref={containerRef}>
          <TextField
            name={'sponsor'}
            label="Sponsor"
            placeholder={'Search by name'}
            onChange={onSearch}
            onFocus={onOpen}
            error={Boolean(searchText && error)}
            helperText={error}
            fullWidth={true}
          />
          {isOpen && (
            <SponsorPopover
              onClose={onClose}
              onSelect={onSelect}
              searchTerm={debouncedSearch}
              anchorEl={containerRef.current}
              onError={onError}
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default SponsorPicker
